import { BrowseByTagsType, ClientEvents } from 'common/events/ClientEvents';
import { QueryParams } from 'common/urls/QueryParams';
import React, { useCallback } from 'react';
import { DishFirstSegmentFilter } from 'src/gqlReactTypings.generated.d';
import { QueryParamsUpdates, QueryParamsUpdateType } from 'src/pages/consumer/explore/useExploreUrl';
import { CategoryCard } from 'src/shared/design-system/CategoryCard/CategoryCard';
import { useTracker } from 'src/shared/hooks/useTracker';
import { BrowseByTagsCollectionTags } from './types';

const imageWidthHeight = {
  width: 684,
  height: 480,
};

export type BrowseByTagsCollectionButtonProps = {
  tag: BrowseByTagsCollectionTags;
  image: string;
  label: string;
  position: number;
  updateQueryParams: (updates: QueryParamsUpdates<DishFirstSegmentFilter>, updateType?: QueryParamsUpdateType) => void;
};

/**
 * Functions like when you click "See All" on a segment
 */
export const CollectionCard: React.FC<BrowseByTagsCollectionButtonProps> = ({
  tag,
  image,
  label,
  position,
  updateQueryParams,
}) => {
  const tracker = useTracker();

  const onClick = useCallback(() => {
    const filters = { [QueryParams.SEGMENT_FILTER]: [tag] };
    updateQueryParams(filters, 'pushIn');
    tracker.track(ClientEvents.BROWSE_BY_TAGS_CLICK, { tag, type: BrowseByTagsType.COLLECTION, position });
  }, [updateQueryParams, tracker, tag, position]);

  return (
    <CategoryCard
      image={image}
      sourceWidth={imageWidthHeight.width}
      sourceHeight={imageWidthHeight.height}
      label={label}
      onClick={onClick}
    />
  );
};
